export enum PrioritizeRequestStatus {
    None = 'None',
    InProgress = 'InProgress',
    Complete = 'Complete',
    Nudged = 'Nudged',
}
